export default class Tel {
  static callOnClick() {
    const $elementParent = $('.tel--info')
    if (navigator.userAgent.match(/(iPhone|iPad|iPod|Android)/)) {
      $elementParent.each(function() {
        const $element = $(this).find('.tel--info-number')
        $element.each(function() {
          $(this).on('click', function() {
            const href =
              'tel:' + $(this)[0]['firstChild']['data'].replace(/-/gi, '')
            window.location.href = href
            return false
          })
        })
      })
    }
  }
}
